import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../pages/api';

const MenuContext = createContext();

const FAQ_MENU_ITEM = {
  id: 'faq-menu-item',
  name: 'FAQ',
  item_type: 'url',
  order: 4,
  is_active: true,
  target: '_self',
  url_path: '/support/faq/',
  subitems: [],
};

const DEFAULT_MENU_ITEMS = [
  { id: 'fallback-home', name: 'Home', url_path: '/', item_type: 'link', order: 0, subitems: [] },
  { id: 'fallback-shop', name: 'Our Tees', url_path: '/shop/', item_type: 'link', order: 2, subitems: [] },
  { id: 'fallback-about', name: 'About', url_path: '/about/', item_type: 'link', order: 3, subitems: [] },
  FAQ_MENU_ITEM,
  { id: 'fallback-contact', name: 'Contact', url_path: '/contact/', item_type: 'link', order: 5, subitems: [] },
];

const MENU_ORDER_BY_PATH = {
  '/': 0,
  '/custom-request': 1,
  '/shop/custom-request': 1,
  '/shop': 2,
  '/about': 3,
  '/support/faq': 4,
  '/contact': 5,
};

const normalizePath = (path = '') => {
  if (!path || path === '/') return '/';
  return path.endsWith('/') ? path.slice(0, -1) : path;
};

const withFaqMenuItem = (items = []) => {
  const activeItems = Array.isArray(items) ? items.filter(Boolean) : [];
  const sourceItems = activeItems.length > 0 ? activeItems : DEFAULT_MENU_ITEMS;
  const hasFaq = sourceItems.some((item) => normalizePath(item.url_path) === '/support/faq');
  const nextItems = hasFaq ? sourceItems : [...sourceItems, FAQ_MENU_ITEM];

  return nextItems
    .map((item) => {
      const normalizedPath = normalizePath(item.url_path);
      const order = MENU_ORDER_BY_PATH[normalizedPath];
      const url_path = normalizedPath === '/shop/custom-request' ? '/custom-request/' : item.url_path;
      const name = normalizedPath === '/shop' ? 'Our Tees' : item.name;
      return order === undefined ? item : { ...item, name, order, url_path };
    })
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
};

export function MenuProvider({ children }) {
  const [menuItems, setMenuItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await api.get('/api/menu/');
        setMenuItems(withFaqMenuItem(response.data));
      } catch (error) {
        console.error('Error fetching menu:', error);
        setMenuItems(withFaqMenuItem([]));
      } finally {
        setIsLoading(false);
      }
    };

    fetchMenu();
  }, []);

  return (
    <MenuContext.Provider value={{ menuItems, isLoading }}>
      {children}
    </MenuContext.Provider>
  );
}

export const useMenu = () => useContext(MenuContext); 
